import { BaseDialog } from '@airship-platform/jam-web/components';
import { InstalledEquipmentResponseExtended } from '../details-page/ExistingSystem';
import SeeDetailsExistingSystem from './SeeDetailsExistingSystem';

const SeeDetailsExistingSystemModal: React.FC<{
  open: boolean;
  equipment: InstalledEquipmentResponseExtended;
  onClose: () => void;
}> = ({ open, equipment, onClose }) => {
  return (
    <BaseDialog open={open} title={''} onClose={() => onClose()}>
      <SeeDetailsExistingSystem equipment={equipment} />
    </BaseDialog>
  );
};

export default SeeDetailsExistingSystemModal;
